export default __webpack_public_path__ + "static/media/patrik.334451e0.jpeg";